// Payment-related translations for all supported languages

export const paymentTranslations = {
  en: {
    // Funding Sources
    'vaiu.payment.add_payment_method': 'Add payment method',
    'vaiu.payment.choose_funding_description': 'Choose how you want to fund your transfers. All methods are secured with bank-grade encryption.',
    'vaiu.payment.bank_account': 'Bank account',
    'vaiu.payment.bank_account_description': 'Securely connect your checking or savings account',
    'vaiu.payment.credit_card': 'Credit or debit card',
    'vaiu.payment.credit_card_description': 'Add Visa, Mastercard, or other major cards',
    'vaiu.payment.paypal': 'PayPal',
    'vaiu.payment.paypal_description': 'Use your existing PayPal account',
    'vaiu.payment.no_fees': 'No fees',
    'vaiu.payment.most_secure': 'Most secure',
    'vaiu.payment.ach_transfers': 'ACH transfers',
    'vaiu.payment.instant_transfers': 'Instant transfers',
    'vaiu.payment.widely_accepted': 'Widely accepted',
    'vaiu.payment.easy_setup': 'Easy setup',
    'vaiu.payment.paypal_balance': 'PayPal balance',
    'vaiu.payment.buyer_protection': 'Buyer protection',
    'vaiu.payment.free': 'Free',
    'vaiu.payment.card_fee': '2.9% + $0.30',
    'vaiu.payment.paypal_fee': '2.5%',
    'vaiu.payment.instant': 'Instant',
    'vaiu.payment.business_days': '1-3 business days',
    'vaiu.payment.recommended': 'Recommended',
    'vaiu.payment.coming_soon': 'Coming soon',
    'vaiu.payment.secure_private': 'Secure and private',
    'vaiu.payment.security_message': 'We use bank-grade encryption and never store your full payment details. All transactions are processed by certified payment processors.',
    'vaiu.payment.help_choosing': 'Need help choosing? Bank accounts offer free transfers but take longer. Cards are instant but include small processing fees.',
    'vaiu.payment.choose_method': 'Choose method',
    'vaiu.payment.setup': 'Setup',
    'vaiu.payment.complete': 'Complete',

    // Funding Source Cards
    'vaiu.payment.credit_card_type': 'Credit card',
    'vaiu.payment.bank_account_type': 'Bank account',
    'vaiu.payment.paypal_wallet': 'PayPal wallet',
    'vaiu.payment.default': 'Default',
    'vaiu.payment.secured': 'Secured',
    'vaiu.payment.active': 'Active',
    'vaiu.payment.set_default': 'Set as default',
    'vaiu.payment.remove': 'Remove',
    'vaiu.payment.set_as_default': 'Set as default',
    'vaiu.payment.inactive_message': 'This payment method is currently inactive and cannot be used for transactions.',
    'vaiu.payment.added_on': 'Added on',
    'vaiu.payment.status': 'Status',

    // Funding Source Selector
    'vaiu.funding.choose_source': 'Choose funding source',
    'vaiu.funding.select_payment_description': 'Choose how you want to pay for this',
    'vaiu.funding.transfer': 'transfer',
    'vaiu.funding.no_payment_methods': 'No payment methods',
    'vaiu.funding.need_payment_method': 'You need to add a payment method before funding this transfer.',
    'vaiu.funding.add_payment_method': 'Add payment method',
    'vaiu.funding.add_another_method': 'Add another payment method',
    'vaiu.funding.transfer_amount': 'Transfer amount',
    'vaiu.funding.card_processing_fee': 'Card processing fee',
    'vaiu.funding.free_ach_transfer': 'Free ACH transfer',
    'vaiu.funding.paypal_processing_fee': 'PayPal processing fee',
    'vaiu.funding.total_pay': 'Total to pay',
    'vaiu.funding.bank_tip': 'Bank transfers are free but take 1-3 business days. Card transfers are instant but include processing fees.',
    'vaiu.funding.select_method': 'Select a payment method',
    'vaiu.funding.continue': 'Continue',

    // Fee Information
    'vaiu.fees.fee': 'Fee',
    'vaiu.fees.speed': 'Speed',
    'vaiu.fees.processing_fee': 'processing fee',
    'vaiu.fees.per_transaction': 'per transaction',
    'vaiu.fees.no_fees_bank': 'No fees for bank transfers',
  },
  // Albanian (Shqip)
  sq: {
    // Funding Sources
    'vaiu.payment.add_payment_method': 'Shto mënyrë pagese',
    'vaiu.payment.choose_funding_description': 'Zgjidhni se si dëshironi të financoni transfertat tuaja. Të gjitha metodat janë të sigurta me kriptim bankar.',
    'vaiu.payment.bank_account': 'Llogari bankare',
    'vaiu.payment.bank_account_description': 'Lidhni llogarinë tuaj rrjedhëse ose kursimeve në mënyrë të sigurt',
    'vaiu.payment.credit_card': 'Kartë krediti ose debiti',
    'vaiu.payment.credit_card_description': 'Shtoni Visa, Mastercard ose karta të tjera kryesore',
    'vaiu.payment.paypal': 'PayPal',
    'vaiu.payment.paypal_description': 'Përdorni llogarinë tuaj ekzistuese PayPal',
    'vaiu.payment.no_fees': 'Pa tarifa',
    'vaiu.payment.most_secure': 'Më i sigurt',
    'vaiu.payment.ach_transfers': 'Transferime ACH',
    'vaiu.payment.instant_transfers': 'Transferime të menjëhershme',
    'vaiu.payment.widely_accepted': 'Gjerësisht i pranuar',
    'vaiu.payment.easy_setup': 'Konfigurimi i lehtë',
    'vaiu.payment.paypal_balance': 'Bilanci PayPal',
    'vaiu.payment.buyer_protection': 'Mbrojtja e blerësit',
    'vaiu.payment.free': 'Falas',
    'vaiu.payment.card_fee': '2.9% + $0.30',
    'vaiu.payment.paypal_fee': '2.5%',
    'vaiu.payment.instant': 'I menjëhershëm',
    'vaiu.payment.business_days': '1-3 ditë pune',
    'vaiu.payment.recommended': 'I rekomanduar',
    'vaiu.payment.coming_soon': 'Së shpejti',
    'vaiu.payment.secure_private': 'I sigurt dhe privat',
    'vaiu.payment.security_message': 'Ne përdorim kriptim bankar dhe nuk ruajmë kurrë detajet e plota të pagesës tuaj. Të gjitha transaksionet përpunohen nga procesorë të certifikuar pagese.',
    'vaiu.payment.help_choosing': 'Keni nevojë për ndihmë në zgjedhje? Llogaritë bankare ofrojnë transferime falas por marrin më shumë kohë. Kartat janë të menjëhershme por përfshijnë tarifa të vogla përpunimi.',
    'vaiu.payment.choose_method': 'Zgjidhni metodën',
    'vaiu.payment.setup': 'Konfigurimi',
    'vaiu.payment.complete': 'Plotëso',

    // Funding Source Cards
    'vaiu.payment.credit_card_type': 'Kartë krediti',
    'vaiu.payment.bank_account_type': 'Llogari bankare',
    'vaiu.payment.paypal_wallet': 'Portofoli PayPal',
    'vaiu.payment.default': 'Parazgjedhur',
    'vaiu.payment.secured': 'I siguruar',
    'vaiu.payment.active': 'Aktiv',
    'vaiu.payment.set_default': 'Vendos si parazgjedhur',
    'vaiu.payment.remove': 'Hiqe',
    'vaiu.payment.set_as_default': 'Vendos si parazgjedhur',
    'vaiu.payment.inactive_message': 'Kjo mënyrë pagese është aktualisht joaktive dhe nuk mund të përdoret për transaksione.',
    'vaiu.payment.added_on': 'Shtuar më',
    'vaiu.payment.status': 'Statusi',

    // Funding Source Selector
    'vaiu.funding.choose_source': 'Zgjidhni burimin e financimit',
    'vaiu.funding.select_payment_description': 'Zgjidhni se si dëshironi të paguani për këtë',
    'vaiu.funding.transfer': 'transferim',
    'vaiu.funding.no_payment_methods': 'Nuk ka mënyra pagese',
    'vaiu.funding.need_payment_method': 'Duhet të shtoni një mënyrë pagese para se të financoni këtë transferim.',
    'vaiu.funding.add_payment_method': 'Shto mënyrë pagese',
    'vaiu.funding.add_another_method': 'Shto mënyrë tjetër pagese',
    'vaiu.funding.transfer_amount': 'Shuma e transferimit',
    'vaiu.funding.card_processing_fee': 'Tarifa e përpunimit të kartës',
    'vaiu.funding.free_ach_transfer': 'Transferim ACH falas',
    'vaiu.funding.paypal_processing_fee': 'Tarifa e përpunimit PayPal',
    'vaiu.funding.total_pay': 'Totali për t\'u paguar',
    'vaiu.funding.bank_tip': 'Transferimet bankare janë falas por marrin 1-3 ditë pune. Transferimet me kartë janë të menjëhershme por përfshijnë tarifa përpunimi.',
    'vaiu.funding.select_method': 'Zgjidhni një mënyrë pagese',
    'vaiu.funding.continue': 'Vazhdo',

    // Fee Information
    'vaiu.fees.fee': 'Tarifa',
    'vaiu.fees.speed': 'Shpejtësia',
    'vaiu.fees.processing_fee': 'tarifa përpunimi',
    'vaiu.fees.per_transaction': 'për transaksion',
    'vaiu.fees.no_fees_bank': 'Pa tarifa për transferime bankare',
  },

  // Russian (Русский)
  ru: {
    // Funding Sources
    'vaiu.payment.add_payment_method': 'Добавить способ оплаты',
    'vaiu.payment.choose_funding_description': 'Выберите, как вы хотите финансировать ваши переводы. Все методы защищены банковским шифрованием.',
    'vaiu.payment.bank_account': 'Банковский счёт',
    'vaiu.payment.bank_account_description': 'Безопасно подключите ваш текущий или сберегательный счёт',
    'vaiu.payment.credit_card': 'Кредитная или дебетовая карта',
    'vaiu.payment.credit_card_description': 'Добавьте Visa, Mastercard или другие основные карты',
    'vaiu.payment.paypal': 'PayPal',
    'vaiu.payment.paypal_description': 'Используйте ваш существующий аккаунт PayPal',
    'vaiu.payment.no_fees': 'Без комиссий',
    'vaiu.payment.most_secure': 'Наиболее безопасный',
    'vaiu.payment.ach_transfers': 'ACH переводы',
    'vaiu.payment.instant_transfers': 'Мгновенные переводы',
    'vaiu.payment.widely_accepted': 'Широко принимается',
    'vaiu.payment.easy_setup': 'Лёгкая настройка',
    'vaiu.payment.paypal_balance': 'Баланс PayPal',
    'vaiu.payment.buyer_protection': 'Защита покупателя',
    'vaiu.payment.free': 'Бесплатно',
    'vaiu.payment.card_fee': '2.9% + $0.30',
    'vaiu.payment.paypal_fee': '2.5%',
    'vaiu.payment.instant': 'Мгновенно',
    'vaiu.payment.business_days': '1-3 рабочих дня',
    'vaiu.payment.recommended': 'Рекомендуется',
    'vaiu.payment.coming_soon': 'Скоро',
    'vaiu.payment.secure_private': 'Безопасно и конфиденциально',
    'vaiu.payment.security_message': 'Мы используем банковское шифрование и никогда не храним полные данные ваших платежей. Все транзакции обрабатываются сертифицированными платёжными процессорами.',
    'vaiu.payment.help_choosing': 'Нужна помощь в выборе? Банковские счета предлагают бесплатные переводы, но занимают больше времени. Карты мгновенные, но включают небольшие комиссии за обработку.',
    'vaiu.payment.choose_method': 'Выберите метод',
    'vaiu.payment.setup': 'Настройка',
    'vaiu.payment.complete': 'Завершить',

    // Funding Source Cards
    'vaiu.payment.credit_card_type': 'Кредитная карта',
    'vaiu.payment.bank_account_type': 'Банковский счёт',
    'vaiu.payment.paypal_wallet': 'Кошелёк PayPal',
    'vaiu.payment.default': 'По умолчанию',
    'vaiu.payment.secured': 'Защищён',
    'vaiu.payment.active': 'Активный',
    'vaiu.payment.set_default': 'Установить по умолчанию',
    'vaiu.payment.remove': 'Удалить',
    'vaiu.payment.set_as_default': 'Установить по умолчанию',
    'vaiu.payment.inactive_message': 'Этот способ оплаты в настоящее время неактивен и не может использоваться для транзакций.',
    'vaiu.payment.added_on': 'Добавлен',
    'vaiu.payment.status': 'Статус',

    // Funding Source Selector
    'vaiu.funding.choose_source': 'Выберите источник финансирования',
    'vaiu.funding.select_payment_description': 'Выберите, как вы хотите оплатить этот',
    'vaiu.funding.transfer': 'перевод',
    'vaiu.funding.no_payment_methods': 'Нет способов оплаты',
    'vaiu.funding.need_payment_method': 'Вам нужно добавить способ оплаты перед финансированием этого перевода.',
    'vaiu.funding.add_payment_method': 'Добавить способ оплаты',
    'vaiu.funding.add_another_method': 'Добавить другой способ оплаты',
    'vaiu.funding.transfer_amount': 'Сумма перевода',
    'vaiu.funding.card_processing_fee': 'Комиссия за обработку карты',
    'vaiu.funding.free_ach_transfer': 'Бесплатный ACH перевод',
    'vaiu.funding.paypal_processing_fee': 'Комиссия за обработку PayPal',
    'vaiu.funding.total_pay': 'Всего к оплате',
    'vaiu.funding.bank_tip': 'Банковские переводы бесплатны, но занимают 1-3 рабочих дня. Переводы картой мгновенные, но включают комиссии за обработку.',
    'vaiu.funding.select_method': 'Выберите способ оплаты',
    'vaiu.funding.continue': 'Продолжить',

    // Fee Information
    'vaiu.fees.fee': 'Комиссия',
    'vaiu.fees.speed': 'Скорость',
    'vaiu.fees.processing_fee': 'комиссия за обработку',
    'vaiu.fees.per_transaction': 'за транзакцию',
    'vaiu.fees.no_fees_bank': 'Без комиссий за банковские переводы',
  },

  // Portuguese (Português)
  pt: {
    // Funding Sources
    'vaiu.payment.add_payment_method': 'Adicionar método de pagamento',
    'vaiu.payment.choose_funding_description': 'Escolha como deseja financiar suas transferências. Todos os métodos são protegidos com criptografia bancária.',
    'vaiu.payment.bank_account': 'Conta bancária',
    'vaiu.payment.bank_account_description': 'Conecte sua conta corrente ou poupança com segurança',
    'vaiu.payment.credit_card': 'Cartão de crédito ou débito',
    'vaiu.payment.credit_card_description': 'Adicione Visa, Mastercard ou outros cartões principais',
    'vaiu.payment.paypal': 'PayPal',
    'vaiu.payment.paypal_description': 'Use sua conta PayPal existente',
    'vaiu.payment.no_fees': 'Sem taxas',
    'vaiu.payment.most_secure': 'Mais seguro',
    'vaiu.payment.ach_transfers': 'Transferências ACH',
    'vaiu.payment.instant_transfers': 'Transferências instantâneas',
    'vaiu.payment.widely_accepted': 'Amplamente aceito',
    'vaiu.payment.easy_setup': 'Configuração fácil',
    'vaiu.payment.paypal_balance': 'Saldo PayPal',
    'vaiu.payment.buyer_protection': 'Proteção do comprador',
    'vaiu.payment.free': 'Grátis',
    'vaiu.payment.card_fee': '2,9% + $0,30',
    'vaiu.payment.paypal_fee': '2,5%',
    'vaiu.payment.instant': 'Instantâneo',
    'vaiu.payment.business_days': '1-3 dias úteis',
    'vaiu.payment.recommended': 'Recomendado',
    'vaiu.payment.coming_soon': 'Em breve',
    'vaiu.payment.secure_private': 'Seguro e privado',
    'vaiu.payment.security_message': 'Usamos criptografia bancária e nunca armazenamos seus detalhes completos de pagamento. Todas as transações são processadas por processadores de pagamento certificados.',
    'vaiu.payment.help_choosing': 'Precisa de ajuda para escolher? Contas bancárias oferecem transferências gratuitas mas demoram mais. Cartões são instantâneos mas incluem pequenas taxas de processamento.',
    'vaiu.payment.choose_method': 'Escolher método',
    'vaiu.payment.setup': 'Configuração',
    'vaiu.payment.complete': 'Concluir',

    // Funding Source Cards
    'vaiu.payment.credit_card_type': 'Cartão de crédito',
    'vaiu.payment.bank_account_type': 'Conta bancária',
    'vaiu.payment.paypal_wallet': 'Carteira PayPal',
    'vaiu.payment.default': 'Padrão',
    'vaiu.payment.secured': 'Protegido',
    'vaiu.payment.active': 'Ativo',
    'vaiu.payment.set_default': 'Definir como padrão',
    'vaiu.payment.remove': 'Remover',
    'vaiu.payment.set_as_default': 'Definir como padrão',
    'vaiu.payment.inactive_message': 'Este método de pagamento está atualmente inativo e não pode ser usado para transações.',
    'vaiu.payment.added_on': 'Adicionado em',
    'vaiu.payment.status': 'Status',

    // Funding Source Selector
    'vaiu.funding.choose_source': 'Escolher fonte de financiamento',
    'vaiu.funding.select_payment_description': 'Selecione como deseja pagar por esta',
    'vaiu.funding.transfer': 'transferência',
    'vaiu.funding.no_payment_methods': 'Nenhum método de pagamento',
    'vaiu.funding.need_payment_method': 'Você precisa adicionar um método de pagamento antes de financiar esta transferência.',
    'vaiu.funding.add_payment_method': 'Adicionar método de pagamento',
    'vaiu.funding.add_another_method': 'Adicionar outro método de pagamento',
    'vaiu.funding.transfer_amount': 'Valor da transferência',
    'vaiu.funding.card_processing_fee': 'Taxa de processamento do cartão',
    'vaiu.funding.free_ach_transfer': 'Transferência ACH gratuita',
    'vaiu.funding.paypal_processing_fee': 'Taxa de processamento PayPal',
    'vaiu.funding.total_pay': 'Total a pagar',
    'vaiu.funding.bank_tip': 'Transferências bancárias são gratuitas mas demoram 1-3 dias úteis. Transferências com cartão são instantâneas mas incluem taxas de processamento.',
    'vaiu.funding.select_method': 'Selecionar um método de pagamento',
    'vaiu.funding.continue': 'Continuar',

    // Fee Information
    'vaiu.fees.fee': 'Taxa',
    'vaiu.fees.speed': 'Velocidade',
    'vaiu.fees.processing_fee': 'taxa de processamento',
    'vaiu.fees.per_transaction': 'por transação',
    'vaiu.fees.no_fees_bank': 'Sem taxas para transferências bancárias',
  },

  // Greek (Ελληνικά)
  el: {
    // Funding Sources
    'vaiu.payment.add_payment_method': 'Προσθήκη μεθόδου πληρωμής',
    'vaiu.payment.choose_funding_description': 'Επιλέξτε πώς θα θέλατε να χρηματοδοτήσετε τις μεταφορές σας. Όλες οι μέθοδοι είναι ασφαλισμένες με τραπεζικό κρυπτογράφηση.',
    'vaiu.payment.bank_account': 'Τραπεζικός λογαριασμός',
    'vaiu.payment.bank_account_description': 'Συνδέστε τον τρεχούμενο ή αποταμιευτικό σας λογαριασμό με ασφάλεια',
    'vaiu.payment.credit_card': 'Πιστωτική ή χρεωστική κάρτα',
    'vaiu.payment.credit_card_description': 'Προσθέστε Visa, Mastercard ή άλλες κύριες κάρτες',
    'vaiu.payment.paypal': 'PayPal',
    'vaiu.payment.paypal_description': 'Χρησιμοποιήστε τον υπάρχοντα λογαριασμό σας PayPal',
    'vaiu.payment.no_fees': 'Χωρίς χρεώσεις',
    'vaiu.payment.most_secure': 'Πιο ασφαλής',
    'vaiu.payment.ach_transfers': 'Μεταφορές ACH',
    'vaiu.payment.instant_transfers': 'Άμεσες μεταφορές',
    'vaiu.payment.widely_accepted': 'Ευρέως αποδεκτή',
    'vaiu.payment.easy_setup': 'Εύκολη εγκατάσταση',
    'vaiu.payment.paypal_balance': 'Υπόλοιπο PayPal',
    'vaiu.payment.buyer_protection': 'Προστασία αγοραστή',
    'vaiu.payment.free': 'Δωρεάν',
    'vaiu.payment.card_fee': '2.9% + $0.30',
    'vaiu.payment.paypal_fee': '2.5%',
    'vaiu.payment.instant': 'Άμεσα',
    'vaiu.payment.business_days': '1-3 εργάσιμες ημέρες',
    'vaiu.payment.recommended': 'Συνιστάται',
    'vaiu.payment.coming_soon': 'Έρχεται σύντομα',
    'vaiu.payment.secure_private': 'Ασφαλής και ιδιωτικός',
    'vaiu.payment.security_message': 'Χρησιμοποιούμε τραπεζική κρυπτογράφηση και δεν αποθηκεύουμε ποτέ τα πλήρη στοιχεία πληρωμής σας. Όλες οι συναλλαγές επεξεργάζονται από πιστοποιημένους επεξεργαστές πληρωμών.',
    'vaiu.payment.help_choosing': 'Χρειάζεστε βοήθεια στην επιλογή; Οι τραπεζικοί λογαριασμοί προσφέρουν δωρεάν μεταφορές αλλά χρειάζονται περισσότερο χρόνο. Οι κάρτες είναι άμεσες αλλά περιλαμβάνουν μικρές χρεώσεις επεξεργασίας.',
    'vaiu.payment.choose_method': 'Επιλογή μεθόδου',
    'vaiu.payment.setup': 'Εγκατάσταση',
    'vaiu.payment.complete': 'Ολοκλήρωση',

    // Funding Source Cards
    'vaiu.payment.credit_card_type': 'Πιστωτική κάρτα',
    'vaiu.payment.bank_account_type': 'Τραπεζικός λογαριασμός',
    'vaiu.payment.paypal_wallet': 'Πορτοφόλι PayPal',
    'vaiu.payment.default': 'Προεπιλογή',
    'vaiu.payment.secured': 'Ασφαλισμένη',
    'vaiu.payment.active': 'Ενεργή',
    'vaiu.payment.set_default': 'Ορισμός ως προεπιλογή',
    'vaiu.payment.remove': 'Αφαίρεση',
    'vaiu.payment.set_as_default': 'Ορισμός ως προεπιλογή',
    'vaiu.payment.inactive_message': 'Αυτή η μέθοδος πληρωμής είναι προς το παρόν ανενεργή και δεν μπορεί να χρησιμοποιηθεί για συναλλαγές.',
    'vaiu.payment.added_on': 'Προστέθηκε στις',
    'vaiu.payment.status': 'Κατάσταση',

    // Funding Source Selector
    'vaiu.funding.choose_source': 'Επιλογή πηγής χρηματοδότησης',
    'vaiu.funding.select_payment_description': 'Επιλέξτε πώς θα θέλατε να πληρώσετε για αυτή τη',
    'vaiu.funding.transfer': 'μεταφορά',
    'vaiu.funding.no_payment_methods': 'Δεν υπάρχουν μέθοδοι πληρωμής',
    'vaiu.funding.need_payment_method': 'Πρέπει να προσθέσετε μια μέθοδο πληρωμής πριν χρηματοδοτήσετε αυτή τη μεταφορά.',
    'vaiu.funding.add_payment_method': 'Προσθήκη μεθόδου πληρωμής',
    'vaiu.funding.add_another_method': 'Προσθήκη άλλης μεθόδου πληρωμής',
    'vaiu.funding.transfer_amount': 'Ποσό μεταφοράς',
    'vaiu.funding.card_processing_fee': 'Χρέωση επεξεργασίας κάρτας',
    'vaiu.funding.free_ach_transfer': 'Δωρεάν μεταφορά ACH',
    'vaiu.funding.paypal_processing_fee': 'Χρέωση επεξεργασίας PayPal',
    'vaiu.funding.total_pay': 'Συνολικό ποσό πληρωμής',
    'vaiu.funding.bank_tip': 'Οι τραπεζικές μεταφορές είναι δωρεάν αλλά χρειάζονται 1-3 εργάσιμες ημέρες. Οι μεταφορές με κάρτα είναι άμεσες αλλά περιλαμβάνουν χρεώσεις επεξεργασίας.',
    'vaiu.funding.select_method': 'Επιλέξτε μια μέθοδο πληρωμής',
    'vaiu.funding.continue': 'Συνέχεια',

    // Fee Information
    'vaiu.fees.fee': 'Χρέωση',
    'vaiu.fees.speed': 'Ταχύτητα',
    'vaiu.fees.processing_fee': 'χρέωση επεξεργασίας',
    'vaiu.fees.per_transaction': 'ανά συναλλαγή',
    'vaiu.fees.no_fees_bank': 'Χωρίς χρεώσεις για τραπεζικές μεταφορές',
  },

  // German (Deutsch)
  de: {
    // Funding Sources
    'vaiu.payment.add_payment_method': 'Zahlungsmethode hinzufügen',
    'vaiu.payment.choose_funding_description': 'Wählen Sie, wie Sie Ihre Überweisungen finanzieren möchten. Alle Methoden sind mit bankähnlicher Verschlüsselung gesichert.',
    'vaiu.payment.bank_account': 'Bankkonto',
    'vaiu.payment.bank_account_description': 'Verbinden Sie Ihr Giro- oder Sparkonto sicher',
    'vaiu.payment.credit_card': 'Kredit- oder Debitkarte',
    'vaiu.payment.credit_card_description': 'Fügen Sie Visa, Mastercard oder andere Hauptkarten hinzu',
    'vaiu.payment.paypal': 'PayPal',
    'vaiu.payment.paypal_description': 'Verwenden Sie Ihr bestehendes PayPal-Konto',
    'vaiu.payment.no_fees': 'Keine Gebühren',
    'vaiu.payment.most_secure': 'Am sichersten',
    'vaiu.payment.ach_transfers': 'ACH-Überweisungen',
    'vaiu.payment.instant_transfers': 'Sofortüberweisungen',
    'vaiu.payment.widely_accepted': 'Weit verbreitet akzeptiert',
    'vaiu.payment.easy_setup': 'Einfache Einrichtung',
    'vaiu.payment.paypal_balance': 'PayPal-Guthaben',
    'vaiu.payment.buyer_protection': 'Käuferschutz',
    'vaiu.payment.free': 'Kostenlos',
    'vaiu.payment.card_fee': '2,9% + 0,30€',
    'vaiu.payment.paypal_fee': '2,5%',
    'vaiu.payment.instant': 'Sofort',
    'vaiu.payment.business_days': '1-3 Werktage',
    'vaiu.payment.recommended': 'Empfohlen',
    'vaiu.payment.coming_soon': 'Demnächst verfügbar',
    'vaiu.payment.secure_private': 'Sicher und privat',
    'vaiu.payment.security_message': 'Wir verwenden bankähnliche Verschlüsselung und speichern niemals Ihre vollständigen Zahlungsdetails. Alle Transaktionen werden von zertifizierten Zahlungsanbietern verarbeitet.',
    'vaiu.payment.help_choosing': 'Benötigen Sie Hilfe bei der Auswahl? Bankkonten bieten kostenlose Überweisungen, dauern aber länger. Karten sind sofort, beinhalten aber kleine Bearbeitungsgebühren.',
    'vaiu.payment.choose_method': 'Methode wählen',
    'vaiu.payment.setup': 'Einrichtung',
    'vaiu.payment.complete': 'Abschließen',

    // Funding Source Cards
    'vaiu.payment.credit_card_type': 'Kreditkarte',
    'vaiu.payment.bank_account_type': 'Bankkonto',
    'vaiu.payment.paypal_wallet': 'PayPal-Wallet',
    'vaiu.payment.default': 'Standard',
    'vaiu.payment.secured': 'Gesichert',
    'vaiu.payment.active': 'Aktiv',
    'vaiu.payment.set_default': 'Als Standard festlegen',
    'vaiu.payment.remove': 'Entfernen',
    'vaiu.payment.set_as_default': 'Als Standard festlegen',
    'vaiu.payment.inactive_message': 'Diese Zahlungsmethode ist derzeit inaktiv und kann nicht für Transaktionen verwendet werden.',
    'vaiu.payment.added_on': 'Hinzugefügt am',
    'vaiu.payment.status': 'Status',

    // Funding Source Selector
    'vaiu.funding.choose_source': 'Finanzierungsquelle wählen',
    'vaiu.funding.select_payment_description': 'Wählen Sie, wie Sie für diese',
    'vaiu.funding.transfer': 'Überweisung',
    'vaiu.funding.no_payment_methods': 'Keine Zahlungsmethoden',
    'vaiu.funding.need_payment_method': 'Sie müssen eine Zahlungsmethode hinzufügen, bevor Sie diese Überweisung finanzieren können.',
    'vaiu.funding.add_payment_method': 'Zahlungsmethode hinzufügen',
    'vaiu.funding.add_another_method': 'Weitere Zahlungsmethode hinzufügen',
    'vaiu.funding.transfer_amount': 'Überweisungsbetrag',
    'vaiu.funding.card_processing_fee': 'Kartenbearbeitungsgebühr',
    'vaiu.funding.free_ach_transfer': 'Kostenlose ACH-Überweisung',
    'vaiu.funding.paypal_processing_fee': 'PayPal-Bearbeitungsgebühr',
    'vaiu.funding.total_pay': 'Gesamtbetrag zu zahlen',
    'vaiu.funding.bank_tip': 'Banküberweisungen sind kostenlos, dauern aber 1-3 Werktage. Kartenüberweisungen sind sofort, beinhalten aber Bearbeitungsgebühren.',
    'vaiu.funding.select_method': 'Zahlungsmethode auswählen',
    'vaiu.funding.continue': 'Weiter',

    // Fee Information
    'vaiu.fees.fee': 'Gebühr',
    'vaiu.fees.speed': 'Geschwindigkeit',
    'vaiu.fees.processing_fee': 'Bearbeitungsgebühr',
    'vaiu.fees.per_transaction': 'pro Transaktion',
    'vaiu.fees.no_fees_bank': 'Keine Gebühren für Banküberweisungen',
  },
};
